import { render } from "./AddToBagV3.vue?vue&type=template&id=af77bd66&scoped=true"
import script from "./AddToBagV3.vue?vue&type=script&lang=js"
export * from "./AddToBagV3.vue?vue&type=script&lang=js"

import "./AddToBagV3.vue?vue&type=style&index=0&id=af77bd66&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af77bd66"]])

export default __exports__